import { computed, Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {

  private readonly percentage = signal(0);

  readonly shouldShow = computed(() => this.percentage() > 0);

  /**
   * Backed by a signal, so templates reading this value (also via shouldShow()) update under OnPush.
   * Kept as a getter/setter so existing callers like `percentageLoaded += 10` keep working.
   */
  get percentageLoaded(): number {
    return this.percentage();
  }

  set percentageLoaded(value: number) {
    this.percentage.set(value);
  }
}
